import { computed } from '@angular/core';
import { Status } from '@bcef/ia-shared';
import { signalStoreFeature, withComputed, withState } from '@ngrx/signals';

export interface LoadingStatusState {
  loadingStatus: Status;
}

export function withLoadingStatus() {
  return signalStoreFeature(
    withState<LoadingStatusState>({ loadingStatus: Status.INITIAL }),

    withComputed(({ loadingStatus }) => ({
      isInitial: computed(() => loadingStatus() === Status.INITIAL),
      isLoading: computed(() => loadingStatus() === Status.PROCESSING),
      isLoaded: computed(() => loadingStatus() === Status.SUCCESS),
      hasError: computed(() => loadingStatus() === Status.FAIL),
    })),
  );
}
